<div class="metro">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div id="second-bar" class="main-menu">
          <div class="menu-left">
            <div (click)="mainMenuOpen()" class="toggle-nav">
              <i class="ri-menu-line sidebar-bar"></i>
            </div>
            <div class="brand-logo">
              <app-header-logo [config]="section!.config"></app-header-logo>
            </div>
          </div>
          <div class="menu-right pull-right">
            <div>
              <app-menu [config]="section!.config"></app-menu>
            </div>
            <div>
              <div class="icon-nav">
                <ul>
                  <li class="onhover-div">
                    <!-- <app-search></app-search>-->
                  </li>
                  <li class="onhover-div">
                    <!-- <a href="javascript:void(0)">
                      <i class="ri-heart-line"> </i>
                    </a> -->
                  </li>
                  <!-- Idioma justo antes del carrito. Va en 3ª posición a propósito: el media
                       query (≤578px) oculta la 1ª y 2ª <li> del icon-nav, así que el combo debe
                       quedar fuera de esas posiciones para seguir visible (al lado del carrito) en móvil. -->
                  <li class="onhover-div language-nav">
                    <app-language></app-language>
                  </li>
                  <li class="onhover-div">
                    <app-cart></app-cart>
                  </li>
                  <li class="onhover-div onhover-dropdown mobile-cart">
                    <!--<app-user-profile></app-user-profile>-->
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>